module.exports = __webpack_public_path__ + "static/img/tiggy_profile_1080x1080.5dfe8ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiggy_profile_1080x1080.jpg
// module id = h5yI
// module chunks = 0